import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import {
  Checkbox,
  Divider,
  FormControlLabel,
  IconButton,
  Radio,
  Tab,
  Tabs,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { Close, FilterAltOutlined, Check } from "@mui/icons-material";
import { font } from "../../styles/font";
import { useEffect, useState } from "react";
import { useApplicationContext } from "../../context/ApplicationContext";
import {
  ModulePath,
  Severity,
  StoryStatus,
} from "../../constant/ApplicationVariables";
import TagIcon from "@mui/icons-material/Tag";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useLocation } from "react-router-dom";
import { getReleaseFolderList_API } from "../../api/controller/PlanningController";
import useErrorHandler from "../../api/errorHandler/useErrorHandler";
import { HttpStatusCode } from "axios";

class Filters {
  static status = "status";
  static createdAt = "createdAt";
  static createdBy = "createdBy";
  static assignedTo = "assignedTo";

  static moduleName = "moduleName";
  static projectName = "projectName";

  static state = "state";
  static type = "type";
  static moscow = "moscow";
  static confidentiality = "confidentiality";
  static priority = "priority";
  static environment = "environment";
  static executionMode = "executionMode";
  static category = "category";
}

export default function FilterDrawerItemDrawer({ open, onClose }) {
  const {
    handleSnackbar,
    setUserStoryList,
    filteredUserStoryList,
    setFilteredUserStoryList,
    currentFilters,
    setCurrentFilters,
    openItemFilterDrawer,
    setOpenItemFilterDrawer,
    toggleChatWindow,
    userStoryPropertiesData,
    setUserStoryPropertiesData,
    useCasePropertiesData,
    setUseCasePropertiesData,
    activeProject,
    setDashboardFilterSelectedRelease,
    setDashboardFilterSelectedSprint,
    selectedReleaseIndex,
    setSelectedReleaseIndex,
    selectedSprintIndex,
    setSelectedSprintIndex,
  } = useApplicationContext();

  const theme = useTheme();
  const pathName = useLocation()?.pathname;

  const errorHandler = useErrorHandler();

  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("release");
  const [filterData, setFilterData] = useState(null);

  const [releaseList, setReleaseList] = useState([]);

  const toggleDrawer = () => {
    handleClose();
  };

  const handleGetCurrentDataState = () => {
    return pathName === ModulePath.requirements
      ? userStoryPropertiesData
      : pathName === ModulePath.useCase
        ? useCasePropertiesData
        : useCasePropertiesData;
  };

  const handleClose = () => {
    onClose();
  };

  const handleChangeTab = (e, newValue) => {
    setActiveTab(newValue);
  };

  const handleClearFilter = () => {
    setSelectedReleaseIndex(null);
    setSelectedSprintIndex(null);
    setDashboardFilterSelectedRelease("");
    setDashboardFilterSelectedSprint("");
  };

  const handleApplyFilter = () => {
    setDashboardFilterSelectedRelease(releaseList[selectedReleaseIndex].name);
    setDashboardFilterSelectedSprint(
      selectedReleaseIndex !== null && selectedSprintIndex !== null
        ? releaseList[selectedReleaseIndex].children[selectedSprintIndex].name
        : "",
    );
    onClose();
  };

  const handleGetReleaseList = async (projectData) => {
    try {
      setLoading(true);

      let projectName = activeProject?.name;
      let query = `name=${projectName}`;

      let response = await getReleaseFolderList_API(query);

      if (response) {
        errorHandler(response, setLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        setReleaseList(response.data);
      }
    } catch (error) {
      console.log(error, error?.message, "releasereponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetReleaseList();
  }, []);

  useEffect(() => {
    if (
      handleGetCurrentDataState() &&
      Object.keys(handleGetCurrentDataState())?.length
    ) {
      setActiveTab(Object.keys(handleGetCurrentDataState())[0]);
    }
  }, []);

  useEffect(() => {
    if (currentFilters) {
      setFilterData(currentFilters);
    }
  }, [currentFilters]);

  console.log(releaseList, "list");

  const DrawerList = (
    <Box
      sx={{ width: 460, height: "100%" }}
      role="presentation"
      className="flex flex-col h-full"
    >
      <Box
        className="flex items-center justify-between px-4 py-2 border-b"
        sx={{
          borderColor: theme.palette.divider,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <FilterAltOutlined sx={{ color: theme.palette.text.primary }} />
        <Typography
          fontSize={font.size.fs_4}
          color={theme.palette.text.primary}
          className="flex-1"
        >
          Filter
        </Typography>

        <IconButton
          onClick={() => toggleDrawer()}
          sx={{
            color: theme.palette.text.secondary,
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          <Close />
        </IconButton>
      </Box>

      <Box
        className="flex-1 flex gap-0 px-0 pt-0"
        sx={{ backgroundColor: theme.palette.background.default }}
      >
        {/* left sidebar - active section tabs */}
        <Box
          className="w-[34%] h-full border-r-0"
          sx={{ borderRight: `1px solid ${theme.palette.divider}` }}
        >
          <Tabs
            value={activeTab}
            orientation="vertical"
            variant="scrollable"
            onChange={handleChangeTab}
            sx={{
              "& .MuiTabs-indicator": {
                backgroundColor: theme.palette.secondary.main,
              },
              "& .MuiTab-root": {
                borderBottom: `1px solid ${theme.palette.divider}`,
                width: "100%",
                minHeight: "48px",
                "&.Mui-selected": {
                  backgroundColor: theme.palette.background.paper,
                },
                whiteSpace: "nowrap",
                textTransform: "none",
                alignItems: "flex-start",
              },
            }}
          >
            <Tab
              key={"release"}
              label={
                <Box className="w-full flex items-center justify-between px-2 gap-1">
                  <Typography
                    fontSize={font.size.fs_5}
                    color={
                      "release" === activeTab
                        ? theme.palette.text.primary
                        : theme.palette.text.secondary
                    }
                    sx={{ fontWeight: "release" === activeTab ? 600 : 400 }}
                  >
                    {`Releases `}
                  </Typography>
                  {releaseList?.length > 0 && (
                    <Box
                      sx={{
                        backgroundColor: theme.palette.secondary.main,
                        color: theme.palette.secondary.contrastText,
                        borderRadius: "12px",
                        padding: "2px 8px",
                        minWidth: "24px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        fontSize={font.size.fs_6}
                        sx={{ fontWeight: 600 }}
                      >
                        {releaseList?.length}
                      </Typography>
                    </Box>
                  )}
                </Box>
              }
              value={"release"}
            />

            <Tab
              key={"sprint"}
              label={
                <Box className="w-full flex items-center justify-between px-2 gap-1">
                  <Typography
                    fontSize={font.size.fs_5}
                    color={
                      "sprint" === activeTab
                        ? theme.palette.text.primary
                        : theme.palette.text.secondary
                    }
                    sx={{ fontWeight: "sprint" === activeTab ? 600 : 400 }}
                  >
                    {`Sprints `}
                  </Typography>
                  {selectedReleaseIndex !== null &&
                    releaseList[selectedReleaseIndex]?.children?.length > 0 && (
                      <Box
                        sx={{
                          backgroundColor: theme.palette.secondary.main,
                          color: theme.palette.secondary.contrastText,
                          borderRadius: "12px",
                          padding: "2px 8px",
                          minWidth: "24px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          fontSize={font.size.fs_6}
                          sx={{ fontWeight: 600 }}
                        >
                          {releaseList[selectedReleaseIndex]?.children?.length}
                        </Typography>
                      </Box>
                    )}
                </Box>
              }
              value={"sprint"}
            />
          </Tabs>
        </Box>

        {/* right main container - active section filters */}
        <Box
          className="flex-1 flex flex-col gap-4 px-4 py-2"
          sx={{
            borderRadius: `0 ${theme.shape.borderRadius} ${theme.shape.borderRadius} 0`,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          {/* Release list */}
          {activeTab === "release" ? (
            <Box className="flex flex-col gap-1">
              <Box className="flex flex-col gap-2">
                {releaseList?.map((item, index) => (
                  <Box
                    key={item.id}
                    className="flex items-center gap-1"
                    sx={{
                      borderBottom: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    <FormControlLabel
                      name={activeTab}
                      value={item?.name}
                      onChange={(e) => {
                        setSelectedReleaseIndex(index);
                      }}
                      control={
                        <Radio
                          checked={selectedReleaseIndex === index}
                          sx={{
                            color: theme.palette.primary.main,
                            "&.Mui-checked": {
                              color: theme.palette.primary.main,
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          fontSize={font.size.fs_5}
                          color={theme.palette.text.primary}
                        >
                          {item?.name}
                        </Typography>
                      }
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          ) : (
            <Box className="flex flex-col gap-1">
              <Box className="flex flex-col gap-2">
                {releaseList[selectedReleaseIndex]?.children?.map(
                  (item, index) => (
                    <Box
                      key={item?.id}
                      className="flex items-center gap-1"
                      sx={{
                        borderBottom: `1px solid ${theme.palette.divider}`,
                      }}
                    >
                      <FormControlLabel
                        name={activeTab}
                        value={item.name}
                        onChange={(e) => {
                          setSelectedSprintIndex(index);
                        }}
                        control={
                          <Radio
                            checked={selectedSprintIndex === index}
                            sx={{
                              color: theme.palette.primary.main,
                              "&.Mui-checked": {
                                color: theme.palette.primary.main,
                              },
                            }}
                          />
                        }
                        label={
                          <Typography
                            fontSize={font.size.fs_5}
                            color={theme.palette.text.primary}
                          >
                            {item?.name}
                          </Typography>
                        }
                      />
                    </Box>
                  ),
                )}
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      <Box
        className="flex gap-4 px-4 py-4"
        sx={{
          borderTop: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Button
          variant="outlined"
          fullWidth
          disabled={isLoading}
          onClick={handleClearFilter}
          sx={{
            textTransform: "none",
            borderRadius: theme.shape.borderRadius,
            borderColor: theme.palette.divider,
            color: theme.palette.text.secondary,
            "&:hover": {
              borderColor: theme.palette.text.primary,
              color: theme.palette.text.primary,
            },
          }}
        >
          Reset
        </Button>
        <Button
          variant="contained"
          fullWidth
          disabled={selectedReleaseIndex === null}
          color="secondary"
          onClick={handleApplyFilter}
          sx={{
            textTransform: "none",
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            "&:hover": {
              backgroundColor: theme.palette.secondary.dark,
            },
            "&:disabled": {
              backgroundColor: theme.palette.action.disabledBackground,
              color: theme.palette.action.disabled,
            },
          }}
        >
          Apply
        </Button>
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => toggleDrawer()}
      SlideProps={{ direction: "right" }}
      PaperProps={{
        style: {
          marginRight: toggleChatWindow ? "0%" : "0%",
          borderRadius: 0,
        },
        sx: {
          backgroundColor: theme.palette.background.default,
        },
      }}
    >
      {DrawerList}
    </Drawer>
  );
}

function KeyValueComponent({ label, children }) {
  const theme = useTheme();

  return (
    <Box
      className="flex flex-col gap-2 border box-border"
      sx={{ borderColor: theme.palette.divider }}
    >
      {label && (
        <Typography
          fontSize={font.size.fs_4}
          className="border-b whitespace-nowrap"
          sx={{
            borderColor: theme.palette.divider,
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          {label}
        </Typography>
      )}
      <Box className="flex-1">{children}</Box>
    </Box>
  );
}
